import React from 'react';
import PropTypes from 'prop-types';
import Page from '../Page';
import SignupForm from '../../components/SignupForm';
import {Elements, ElementsConsumer} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const Signup = (props) => {
  return (
    <Page { ...props } alignment="left" heading="Registreren">
      <div>
        <p>Vul hieronder je contact-, betaal- en factuurgegevens in. De API key wordt vervolgens naar het e-mailadres van de opgegeven contactpersoon verstuurd. Dit e-mailadres wordt ook gebruik voor belangrijke technische correspondentie en om je instellingen te wijzigen. Wij raden daarom aan om een e-mailadres te gebruiken dat toegankelijk is voor meerdere personen (zoals tech@ of info@).</p>
      </div>
      {(navigator.userAgent !== "ReactSnap") && (
        <Elements stripe={stripePromise}>
          <ElementsConsumer>
            {({elements, stripe}) => (
              <SignupForm {...props} stripe={stripe} elements={elements}/>
            )}
          </ElementsConsumer>
        </Elements>
      )}
    </Page>
  )
};

Signup.propTypes = {
  head: PropTypes.object.isRequired,
};

export default Signup;
